<template>
    <div class="home">
        <div class="home-title">
            <el-card shadow="always">
                <div class="title-msg">工作台</div>
                <el-row>
                    <el-col :span="1" :offset="1">
                        <el-avatar :size="60" ><i class="el-icon-user-solid"></i></el-avatar>
                    </el-col>
                    <el-col :span="5">
                        <div class="greetings">早上好,admin,祝你新的一天工作愉快</div>
                        <div class="weather">今天小雨转阴天,21~27°,天凉,注意加衣</div>
                    </el-col>
                   
                </el-row>
            </el-card>
        </div>
    </div>
</template>


<style lang="less">


    .home {
        padding-bottom: 4em;

        .home-title {
            .title-msg {
                font-size: 20px;
                padding-bottom: 2rem;
            }

            .greetings {
                font-size: 18px;
                line-height: 30px;
                letter-spacing: .1em;
            }

            .weather {
                font-size: 14px;
                color: #999;
                line-height: 24px;
                letter-spacing: .1em;
            }

            .item {
                color: #808695;
                text-align: center;
                padding: 0.5em;
            }

            .item-text {
                font-weight: 700;
                font-size: 20px;
                color: #000000;
            }
        }

        .home-card {
            .card-text {
                font-size: 12px;
                font-weight: 400;
                color: #494b52;
                letter-spacing: .1em;
                padding-top: 0.4em;
            }
        }

        .home-chart {
            .satisfaction {
                padding-top: 0.2em;
                text-align: center;
            }

            .satisfaction-number {
                font-weight: 700;
                font-size: 30px;
                color: #515a6e;
                line-height: 120px;
                text-align: center;
            }

            .satisfaction-image {
                width: 60px;
                height: 60px;
                text-align: center;
            }

            .satisfaction-msg {
                line-height: 35px;
                color: #808695;
                font-size: 14px;
                text-align: center;
            }

            .satisfaction-ratio {
                line-height: 120px;
                color: #36c17b;
                font-size: 18px;
                text-align: center;
            }

            .sale-item {
                border-radius: 0.2em;
                line-height: 3.2em;
                text-align: center;
                margin: 1em 0;

                .item-image {
                    top: 0.6em;
                }

                .item-num {
                    height: 2.4em;
                    line-height: 2.4em;
                    color: white;
                    font-weight: bold;
                    font-size: 20px;
                    text-align: right;
                    padding-right: 1em;
                }
            }
        }
    }
</style>